module.exports = __webpack_public_path__ + "img/bg-blue-og.8c90d780.png";